module.exports = __webpack_public_path__ + "img/siege_defence.6f78ec84.png";